export interface ConfigurationEconde {
    key: string,
    keyLength: number,
    iv: string,
    ivLength: number
}

class ConfigurationEncoder {
    public async getConfiguration() {
        const response = await fetch(process.env.PUBLIC_URL + "/manifest.json");
        const dataJson = await response.json();
        
        return dataJson.configurationEncode;
    }
}
 
export const configurationEncoder = new ConfigurationEncoder();